module.exports = "/_next/static/images/img__black-friday_2_desktop-6dc58af8efbe0c55fbb6018b65d4df21.png";